import React, { useEffect } from "react";
import PageShell from "../components/PageShell";

const Privacy = () => {
  useEffect(() => {
    document.title = "Privacy Policy — topastrologerinindia.com";
  }, []);
  return (
    <PageShell title="Privacy Policy" subtitle="Effective from July 2025. Last updated June 2026.">
      <p className="text-[15px] leading-relaxed text-slate-700">
        topastrologerinindia.com ("we", "us", "our") is an independent editorial platform that
        publishes a ranked list of trusted astrologers in India. This Privacy Policy explains what
        information we collect, how we use it, and the choices you have. By using this website,
        you agree to the terms of this policy.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">1. Information we collect</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        We do <strong>not</strong> ask you to create an account or share personal details to view
        our content. We collect only the standard, anonymous analytics that any modern website
        collects:
      </p>
      <ul className="list-disc pl-6 mt-2 space-y-1 text-[15px] text-slate-700">
        <li><strong>Usage data</strong> via Google Analytics (page views, device type, country, referrer).</li>
        <li><strong>Advertising attribution</strong> (Google Ads click identifier — GCLID — stored as a cookie if you arrive via a paid ad).</li>
        <li><strong>Click events</strong> when you tap a WhatsApp button — we record the astrologer's name and ID, never your phone number or message.</li>
      </ul>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">2. What we do <em>not</em> collect</h2>
      <ul className="list-disc pl-6 space-y-1 text-[15px] text-slate-700">
        <li>We do not store your phone number, birth chart, or conversation with an astrologer.</li>
        <li>We do not run any payment processing on this website.</li>
        <li>We do not sell or rent any data to third parties.</li>
      </ul>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">3. Cookies</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        We use first-party cookies set by Google Analytics (<code>_ga</code>, <code>_ga_*</code>)
        and Google Ads (<code>_gcl_aw</code>) for analytics and ad-attribution. You can clear or
        block these in your browser settings at any time.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">4. Third-party services</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        When you tap "WhatsApp Now", you are sent to WhatsApp's official click-to-chat service at
        <code> wa.me</code>. WhatsApp's own privacy policy then applies to that chat. We do not see
        or store the contents of your conversation with the astrologer.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">5. Children</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        This website is intended for users 18 years of age or older. We do not knowingly collect
        information from anyone under 18.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">6. Your rights</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        You can request deletion of any data we hold about you (typically only analytics cookies)
        by emailing <a href="mailto:sachinsharma6886@gmail.com" className="text-[#16a3a8] font-semibold">sachinsharma6886@gmail.com</a>.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">7. Changes to this policy</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        We may update this Privacy Policy from time to time. The "Last updated" date at the top of
        this page indicates the latest revision.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">8. Contact</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Editorial   ·   topastrologerinindia.com<br />
        Email: <a href="mailto:sachinsharma6886@gmail.com" className="text-[#16a3a8] font-semibold">sachinsharma6886@gmail.com</a>
      </p>
    </PageShell>
  );
};

export default Privacy;
